import { Layout } from "antd"
import React from "react"

const { Content } = Layout

const Minimal = (props) => {
  const { children } = props

  const childrenWithProps = React.Children.map(children, (element) =>
    React.cloneElement(element, {})
  )

  return (
    <>
      <div className="flex flex-col w-full min-h-full">
        <Layout className="min-h-screen">
          <Content>{childrenWithProps}</Content>
        </Layout>
      </div>
    </>
  )
}

export default Minimal
